import React from "react";
import {Brands} from "@core-ui/utility";
import {useTheme} from "@core-ui/react-stitch";
import {Icon} from "../components/Icon";
import {IconContainerProps, ColorTheme} from "../types";

export const ArrowIcon = (props: IconContainerProps): JSX.Element => {
  const theme = useTheme();
  const {colorTheme} = props;
  const isLight = colorTheme === ColorTheme.light;

  const GapSVG = (
    <svg viewBox="0 0 32 28.7" xmlns="http://www.w3.org/2000/svg">
      <g fill={isLight ? theme.color.wh : theme.color.b1}>
        <path d="M29.4 15.1H0v-2h29.4Z" />
        <g>
          <path d="m30.2 15.4-14-14L17.6 0l14 14Z" />
          <path d="m16.2 27.3 14.3-14.4 1.5 1.4-14.4 14.4Z" />
        </g>
      </g>
    </svg>
  );

  const brandIconSVGs = {
    [Brands.Athleta]: null,
    [Brands.BananaRepublic]: null,
    [Brands.BananaRepublicFactoryStore]: null,
    [Brands.Gap]: GapSVG,
    [Brands.GapFactoryStore]: GapSVG,
    [Brands.OldNavy]: null,
    crossBrand: null,
  };

  return <Icon {...props} brandIconSVGs={brandIconSVGs} />;
};
